export { default as Form } from 'providers/components/form/ProviderForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/form/index.js